import { Route, Routes } from "react-router";
import Homepage from "../pages/homepage/homepage";
// import Landingpage from "../pages/landingpage/landingpage";

const Routers = () => {
  return (
    <>
      {/* <Switch>
        <Route exact path="/">
          <Homepage />
        </Route>
      </Switch> */}
      <Routes>
        <Route path="/" element={<Homepage />} />
      </Routes>
      {/* <Routes>
        <Route path="/landing" element={<Landingpage />} />
      </Routes> */}
    </>
  );
};

export default Routers;
